module.exports = __webpack_public_path__ + "img/honeyhap_logo.2debb0ce.png";